import { UserDialogService } from '../../shared/services/user-dialog.service';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface UserDialogStageData {
  stage: string;
}

export interface UserDialogData {
  initialStage?: UserDialogStage;
}

export enum UserDialogStage {
  updating_user = 'UPDATING_USER',
  updating_subs = 'UPDATING_SUBSCRIPTIONS',
  updating_roles = 'UPDATING_ROLES',
  creating_user = 'CREATING_USER',
  close = 'CLOSE',
  sending_activation_email = 'SENDING_ACTIVATION_EMAIL',
}

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss'],
})
export class UserDialogComponent {
  dialogState: string = UserDialogStage.updating_user;
  stage = UserDialogStage;
  subscriptionProgress = '';

  constructor(
    private userDialogService: UserDialogService,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserDialogData,
  ) {
    // Set initial stage if provided, otherwise default to updating_user
    const initialStage = data?.initialStage || UserDialogStage.updating_user;
    this.dialogState = initialStage;
    this.userDialogService.setStage(initialStage);

    this.userDialogService.currentStageProgress.subscribe((data: UserDialogStageData) => {
      if (data) {
        if (data.stage == 'CLOSE') {
          this.closeDialog();
        }
        this.dialogState = data.stage;
      }
    });
    this.userDialogService.currentSubscriptionProgress.subscribe((data: any) => {
      if (data) {
        this.subscriptionProgress = data.progress;
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
